// extracted by mini-css-extract-plugin
module.exports = {"signalPanel":"signalPanelStyle_signalPanel__3zICD"};